/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';

export type UseBrushEventListenersInput = {
    ref: React.MutableRefObject<HTMLElement>;
    attachedToRef: React.MutableRefObject<HTMLElement>;
    getCoordinates: (e: MouseEvent) => { top: number; left: number };
};

export const useBrushEventListeners = (input: UseBrushEventListenersInput) => {
    const { ref, attachedToRef, getCoordinates } = input;

    React.useEffect(() => {
        const handleMouseMove = (e: MouseEvent) =>
            requestAnimationFrame(() => {
                const { left, top } = getCoordinates(e);
                if (ref.current) {
                    ref.current.style.top = `${top}px`;
                    ref.current.style.left = `${left}px`;
                }
            });

        const handleMouseEnter = () =>
            requestAnimationFrame(() => {
                if (ref.current) {
                    ref.current.style.opacity = '1';
                }
            });
        const handleMouseLeave = () =>
            requestAnimationFrame(() => {
                if (ref.current) {
                    ref.current.style.opacity = '0';
                }
            });

        attachedToRef.current?.addEventListener('mousemove', handleMouseMove);
        attachedToRef.current?.addEventListener('mouseenter', handleMouseEnter);
        attachedToRef.current?.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            if (attachedToRef.current) {
                attachedToRef.current.removeEventListener('mousemove', handleMouseMove);
                attachedToRef.current.removeEventListener('mouseenter', handleMouseEnter);
                attachedToRef.current.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [getCoordinates]);
};
